"use client";

import React from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useTheme } from "@/app/theme-provider";

const MediaGalleryCarousel = dynamic(
  () => import("@/Components/MediaGalleryCarousel"),
  {
    ssr: false,
    loading: () => null,
  }
);

export default function MediaGallery({
  initialList = [],
}) {
  const { language } = useTheme();

  return (
    <section className="cmpad mt-40">
      <div className="row">
        <div className="col-lg-6 col-md-6 col-12">
          <h2 className="head-h">{language == "en" ? "Media Gallery" : "മീഡിയ ഗാലറി"}</h2>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <div className="d-flex gap-3 align-item-center justify-content-end p-3 tab-container">
            <div className="tab-item active-tab">
              <span>{language == "en" ? "Photos" : "ഫോട്ടോകൾ"}</span>
              <div className="tab-arrow" />
            </div>
            <button className="view-btn">
              <Link href="/gallery">{language == "en" ? "View All" : "എല്ലാം കാണുക"}</Link>
              <div className="View-icons"><img src="/icons/arrow.svg" alt="arrow" /></div>
            </button>
          </div>
        </div>
      </div>
      {initialList?.length > 0 ? <MediaGalleryCarousel list={initialList} /> : null}
    </section>
  );
}
